export default class Desk {
  static createItem (item) {
    const desk = Object.assign(new Desk(), {
      description: item.description,
      displayName: item.displayName,
      id: item.id,
      updateDate: item.updateDate,
      updateUserId: item.updateUserId,
      _src: item
    })

    return desk
  }
}
